module.exports = "/virtual-football-league/img/amblems/left/logos/Rev.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Rev.png
// module id = 2121
// module chunks = 4